import React, { useEffect } from 'react';
import CONFIG from '../../config';
import { useAuth } from '../../hooks/useAuth';
import { useParams } from 'react-router-dom';
/*

Logikk:
1. Kosapi produserer en url med token på formen 
   ../wsuserlogin/../../<token goes here>
   Dette endepunktet må ikke kreve at man er pålogget
2. Man gjør et oppslag mot backend der tokenet sendes inn
3. Dersom backend godtar tokenet, logges brukeren i tokenet inn
   Brukeren må være en Webservice bruker, andre godtas ikke
4. Man gjennomfører login i react applikasjonen
5. Man kan fortsette som vanlig

Når dette går i prod, kan vanlig login avvise alle ws brukere

*/

let gBaseUrl = window.location.protocol + '//' + window.location.hostname + ":" + window.location.port + '/'
if (process.env.NODE_ENV === 'development') {
    //gBaseUrl = 'http://localhost:5000/'
    gBaseUrl = CONFIG.DEBUG_SERVER
}


const WsUserLoginContainer = () => {

    const auth = useAuth();
    const { crNo, caseId, token } = useParams();

    useEffect(() => {

        console.log('wsuserlogin', token)
        
        // Logg av gammel bruker dersom du er pålogget
        auth.logOut()  
        
        let startPage = `/CaseDetails/${crNo}/${caseId}`

        // Kjør en fetch med eksisterende token mot WsUserAuth
        // Dersom du får token fra denne, kan du kjøre auth.TokenSignIn med 
        // Tokenet du fikk tilbake

        fetch(`${gBaseUrl}api/ApiSecurity/WsUserAuth`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Origin': '',
                Authorization: `Bearer ${token}`
            }
        })
        .then(resp => resp.json())
        .then(
            json => {
                console.log(JSON.stringify(json))
                
                let jsonToken = json.token

                if (jsonToken) {
                    console.log(jsonToken);                    
                    auth.tokenSignIn(jsonToken, startPage)
                }
            })
        .catch(e => {
            console.log(e)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, crNo, caseId])

    return (
        <>
            <h1>Webservicebruker pålogging avvist.</h1>
        </>
    )
}

export default WsUserLoginContainer
